/**
 * Create a query string from an object of query params
 * @param params Object of all the query params
 * @returns query string
 */
export const createSearchParams = (params: Record<string, string>) => {
  return new URLSearchParams(params).toString()
}

/**
 * Create a URL with query params
 * @param path URL path
 * @param params Object of all the query params
 * @returns URL with query params
 */
export const getURL = (path: string, params: Record<string, string> = {}) => {
  const url = new URL(path)
  url.search = createSearchParams(params)
  return url
}
